import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-claro-loading',
  templateUrl: './claro-loading.component.html',
  styleUrls: ['./claro-loading.component.scss']
})
export class ClaroLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
